import React from 'react';
import SeoHead from '../components/SeoHead';
import { CORE_PAGE_SEO } from '../data/corePageSeo';

const About = () => {
  const seo = CORE_PAGE_SEO.about;

  return (
    <main>
      <SeoHead title={seo.title} description={seo.description} path={seo.path} />
      {/* Page Banner */}
      <section className="page-banner block-space text-white" style={{ backgroundColor: 'var(--secondary-color)' }}>
        <div className="container">
          <h1 className="display-4 fw-bold">About Easy Drop Taxi</h1>
          <p className="lead">Your trusted partner in mobility</p>
        </div>
      </section>

      {/* About Content */}
      <section className="about-content block-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-4">
              <h2 className="mb-4" style={{ color: 'var(--secondary-color)' }}>Who We Are</h2>
              <p>
                Easy Drop Taxi is a leading taxi service provider in Coimbatore, dedicated to providing reliable, affordable, 
                and professional transportation solutions. With years of experience in the industry, we have built a reputation 
                for excellence and customer satisfaction.
              </p>
              <p>
                Our mission is simple: to make quality taxi services accessible to everyone. We believe that every journey 
                should be comfortable, safe, and delivered at a fair price.
              </p>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="about-image p-4" style={{ backgroundColor: 'var(--primary-color)', borderRadius: '8px' }}>
                <i className="fa fa-building" style={{ fontSize: '100px', color: 'var(--secondary-color)' }}></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="our-values block-space bg-light">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="value-card card h-100 p-4">
                <div className="value-icon mb-3" style={{ color: 'var(--primary-color)', fontSize: '2rem' }}>
                  <i className="fa fa-heart"></i>
                </div>
                <h5>Customer First</h5>
                <p>We prioritize customer satisfaction in everything we do.</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="value-card card h-100 p-4">
                <div className="value-icon mb-3" style={{ color: 'var(--primary-color)', fontSize: '2rem' }}>
                  <i className="fa fa-shield"></i>
                </div>
                <h5>Safety & Reliability</h5>
                <p>Your safety is our top priority with well-maintained vehicles.</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="value-card card h-100 p-4">
                <div className="value-icon mb-3" style={{ color: 'var(--primary-color)', fontSize: '2rem' }}>
                  <i className="fa fa-check"></i>
                </div>
                <h5>Integrity</h5>
                <p>Transparent pricing and honest service every time.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="statistics block-space">
        <div className="container">
          <div className="row text-center">
            <div className="col-md-3 mb-4">
              <h3 className="display-5" style={{ color: 'var(--primary-color)' }}>5000+</h3>
              <p>Happy Customers</p>
            </div>
            <div className="col-md-3 mb-4">
              <h3 className="display-5" style={{ color: 'var(--primary-color)' }}>50+</h3>
              <p>Professional Drivers</p>
            </div>
            <div className="col-md-3 mb-4">
              <h3 className="display-5" style={{ color: 'var(--primary-color)' }}>100+</h3>
              <p>Quality Vehicles</p>
            </div>
            <div className="col-md-3 mb-4">
              <h3 className="display-5" style={{ color: 'var(--primary-color)' }}>10+</h3>
              <p>Years Experience</p>
            </div>
          </div>
        </div>
      </section>

      
    </main>
  );
};

export default About;
